/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 27.04.2016.
 */
import ReducerAuth from './reducer-auth';

export default ReducerAuth;



// WEBPACK FOOTER //
// ./src/reducers/auth/index.js